import { sortBy } from 'ramda';
import { bytesToGB } from 'reactApp/utils/sizeHelper';
import { createSelector } from 'reselect';

import { getBillingDataRoot } from './billingData.selectors';

const getReferralList = createSelector(getBillingDataRoot, (state) => state.referral);

const getReferralById = createSelector(
    getReferralList,
    (_, id) => id,
    (list, id) => list.find((item) => id === item.id)
);

const getReferralCommonQuota = createSelector(getReferralList, (list) =>
    bytesToGB(
        list.reduce((prev, curr) => {
            return prev + curr.quota.original;
        }, 0)
    )
);

const getReferralsCount = createSelector(getReferralList, (list) => list.length);

const sortReferralsByExpires = createSelector(getReferralList, (list) => sortBy(({ expires }) => expires, list));

export const BillingDataReferralSelectors = {
    getReferralById,
    getReferralCommonQuota,
    sortReferralsByExpires,
    getReferralsCount,
} as const;
